import Collection from './collection.js';
import Bank from 'newModels/bank.js';

export default class Banks extends Collection {
    url() {
        return '/Banks';
    }

    initialize() {
        super.initialize(...arguments);
        this.model = Bank;
        this.pagination = false;
        return this;
    }
}



// WEBPACK FOOTER //
// ./app/new-collections/banks.js